import { toast } from "react-toastify";
import { axios } from "../../utils/axios";
import { toastOptions } from "../../config/toast";

export const getPrecioUnidad = async (setPrecioUnidad, setPrecioUnidadIsLoading) => {
  const result = await axios().get("precio_unidad");
  const { data, error } = result.data;
  if (data) {
    setPrecioUnidad(data.value);
  }
  if (error) {
    toast.error(error, toastOptions);
  }
  setPrecioUnidadIsLoading(false);
};
